<template>
  <button
    v-if="isPermitted"
    :class="['btn', context]"
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="disabled"
    :type="$attrs.type ? $attrs.type : 'button'"
  >
    <div :class="['relative flex items-center justify-center', size]">
      <span
        :class="[
          'space-x-2 items-center justify-center w-full truncate',
          font,
          $attrs.loading ? 'hidden' : 'flex',
        ]"
      >
        <slot />
        <span>{{ text }}</span>
      </span>
      <slot name="after" />
      <base-icon
        v-if="$attrs.loading"
        icon="spinner-btn"
        :class="['animate-spin']"
        style="font-size: 150%"
      />
    </div>
  </button>
</template>

<script>
import {btnStyle} from '@/state/helpers/mixins.js'
import {btns} from '@/state/helpers/buttons.js'

import BaseIcon from './_base-icon.vue'

export default {
  components: {
    BaseIcon,
  },
  mixins: [btnStyle],
  props: {
    action: {
      required: true,
    },
  },
  computed: {
    isPermitted() {
      return typeof btns[this.action] !== 'undefined'
        ? this.$store.getters['auth/isPermitted'](btns[this.action].permission)
        : true
    },
    text() {
      return typeof btns[this.action] !== 'undefined'
        ? this.$te(`mygwf.components.Button.${btns[this.action].label}`)
          ? this.$t(`mygwf.components.Button.${btns[this.action].label}`)
          : btns[this.action].label
        : ''
    },
    context() {
      return typeof this.$attrs.context !== 'undefined'
        ? `btn-${this.$attrs.context}`
        : 'btn-primary'
    },
    disabled() {
      return this.$attrs.loading || this.$attrs.disabled
    },
  },
}
</script>

<style scoped>
.btn {
  @apply font-semibold relative p-0 m-0 leading-normal transition duration-100 ease-linear;
}

.btn:focus {
  @apply outline-none ring;
}

.btn:disabled {
  @apply opacity-50 cursor-default;
}

.btn-primary {
  @apply text-white bg-primary;
}

.btn-primary:hover {
  @apply bg-primary-light;
}

.btn-primary:hover:disabled {
  @apply bg-primary;
}

.btn-secondary {
  @apply bg-secondary;
}

.btn-secondary:hover {
  @apply bg-white shadow-sm;
}

.btn-secondary:hover:disabled {
  @apply bg-secondary;
}

.btn-outline {
  @apply bg-white;
}

.btn-outline:hover {
  @apply bg-secondary shadow-sm;
}
.btn-outline:disabled {
  @apply bg-white;
}
.btn-outline:hover:disabled {
  @apply bg-white;
}

.btn-success {
  @apply text-white bg-green-default;
}

.btn-success:hover {
  @apply bg-green-light;
}

.btn-success:hover:disabled {
  @apply bg-green-default;
}

.btn-error {
  @apply text-white bg-red-default;
}

.btn-error:hover {
  @apply bg-red-light;
}

.btn-error:hover:disabled {
  @apply bg-red-default;
}

.btn-info {
  @apply text-white bg-blue-default;
}

.btn-info:hover {
  @apply bg-blue-light;
}

.btn-info:hover:disabled {
  @apply bg-blue-default;
}

.btn-warning {
  @apply text-white bg-orange-default;
}

.btn-warning:hover {
  @apply bg-orange-light;
}

.btn-warning:hover:disabled {
  @apply bg-orange-default;
}
</style>
